module.exports = __webpack_public_path__ + "img/profile-image-generic.c1c5a5d0.svg";